












import {defineComponent, PropType, ref, Ref, watch} from "@vue/composition-api"
import ActivationModal from "./components/modal/ModalComponent.vue"
import ActivationComponent from "./components/ActivationComponent.vue"
import {Config} from "./models/config-viewmodel";
import {useActions, useGetters} from "vuex-composition-helpers";

export default defineComponent({
    name: "MyStudyChoiceActivationWidget",
    components: {ActivationComponent, ActivationModal},
    props: {
        config: {
            type: Object as PropType<Config>,
            required: true
        }
    },
    setup: (props) => {
        const {setConfig} = useActions(['setConfig']);
        const {toggleModal} = useGetters(['toggleModal']);
        setConfig(props.config)
        const activation: Ref<boolean> = ref(true);
        
        watch(() => toggleModal.value, function () {
            activation.value = !activation.value
        });
        
        return {
            activation
        }
    }
})
